import { createLoadingScreen, createTableBodyLoadingIndicator, createTdWithText } from "../DomUtilities/ElementsCreator";
import { insertBody } from "../DomUtilities/ElementsUtil";
import openErrorModal from "../Error/ErrorModal";
import { fetchEconomicMissingOrdersList as fetchEconomicMissingOrdersList, retryInvoicingStoresWithMissingOrders } from "../HTTPRequests/EconomicErrorsRequest";
import EconomicMissingOrdersViewModel from "../Models/ViewModels/EconomicErrorViewModel";
import PageModel from "../Models/ViewModels/PageModel";
import ITablePaginator from "../Pagination/ITablePaginator";
import TablePaginator from "../Pagination/TablePaginator";
import Mediator from "../Utilities/Mediator";

export default class EconomicMissingOrders implements ITablePaginator {
    table: HTMLTableElement;
    paginator: TablePaginator;
    retryBtn: HTMLButtonElement;
    loadingScreen: HTMLElement;

    constructor() {
        this.table = document.querySelector('#economic-Missing-Orders');
        this.retryBtn = document.querySelector('#retry-missing-orders-button');
        this.paginator = new TablePaginator(this);
        this.loadingScreen = createLoadingScreen()
        this.retryClickListener();

        this.init();
    }
    
    private init(): void {
        Mediator.on("retryInvoicingMissingOrdersFinished", () => this.fetchList());
        this.fetchList();
        this.paginator.addPaginationEventsListeners();
    }

    public async fetchList(): Promise<void> {
        this.showLoadingIndicator(); 
        try {
            const response: PageModel<EconomicMissingOrdersViewModel> = await fetchEconomicMissingOrdersList(
                this.paginator.currentPage, 
                this.paginator.pageSize
            );
            this.updateTable(response);
        } catch (error) {
            openErrorModal();
        }
    }

    private showLoadingIndicator() {
        insertBody(this.table, createTableBodyLoadingIndicator());
    }

    private updateTable(data: PageModel<EconomicMissingOrdersViewModel>) {
        this.paginator.currentPage = data.pageNumber;
        this.paginator.total = data.total;
        this.paginator.pageSize = data.pageSize;
        this.renderTable(data.list);
    }    

    private renderTable(list: Array<EconomicMissingOrdersViewModel>) {
        insertBody(this.table,
            this.renderBody(list)
        );
        this.paginator.renderFoot();
    }

    private renderBody(economicMissingOrdersList: Array<EconomicMissingOrdersViewModel>) {
        const tbody = document.createElement('tbody');
        if (economicMissingOrdersList.length) {

            for (const economicMissingOrder of economicMissingOrdersList) {
                const row = this.createStoreTableRow(economicMissingOrder);
                tbody.append(row);
            }

        } else {
            this.retryBtn.classList.add("disabled");
            this.retryBtn.disabled = true;
            tbody.append(this.createEmptyListTableRow());
        }

        return tbody;
    }

    private createStoreTableRow(economicMissingOrder: EconomicMissingOrdersViewModel): HTMLTableRowElement {
        const tr = document.createElement('tr');
        tr.classList.add('table__row', 'no-align-end');

        const tdCustomerName = createTdWithText(economicMissingOrder.customerName);
        tr.append(tdCustomerName);

        const tdOrderId = createTdWithText(economicMissingOrder.orderId);
        tr.append(tdOrderId);

        const tdStore = createTdWithText(economicMissingOrder.storeName);
        tr.append(tdStore);

        const tdDeliveredDate = createTdWithText(economicMissingOrder.deliveredDate);
        tr.append(tdDeliveredDate);

        return tr;
    }

    private createEmptyListTableRow(): HTMLTableRowElement {
        const emptyText = this.table.dataset.empty;
        const tr = document.createElement('tr');
        const td = createTdWithText(emptyText);
        td.colSpan = this.table.querySelectorAll('th').length;
        td.style.textAlign = 'center';
        tr.append(td);

        return tr;
	}

    private openSuccessMsgModal() {
        const modal: HTMLDivElement = document.querySelector("#retry-missing-orders-button");
        let message: string = modal.dataset.msg;
        openErrorModal(message, "#AAC291", "  ", "30%", "165px");
    }

    private retryClickListener() {
        this.retryBtn.onclick = () => {
            document.body.append(this.loadingScreen);
            this.retryInvoicingMissingOrders();
        }
	}
    
    private async retryInvoicingMissingOrders() {
        try {
            await retryInvoicingStoresWithMissingOrders();
            this.openSuccessMsgModal();
            Mediator.emit("retryInvoicingMissingOrdersFinished");
        } catch (error) {
            openErrorModal();
        } finally {
            this.loadingScreen.remove();
        }
    }
}
